module.exports = __webpack_public_path__ + "images/kymco_smalla01ff3e65563c296ce519aaefabca752.png";